// src/firebaseMessagingHandler.js
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebase';
import { store } from './app/store';

export function setupFirebaseMessaging() {
  onMessage(messaging, (payload) => {
    console.log(payload, 'payload 009')
    const state = store.getState();
    const currentChatId = state.chat.openChatId;
    const incomingChatId = payload.data?.agreementId;

    if ( currentChatId !== incomingChatId ) {
      // new Notification(payload.notification.title, {
      //   body: payload.notification.body,
      //   icon: '/chat-icon.png',
      //   data: {
      //     agreementId: incomingChatId,
      //   },
      // });
    } else {
      console.log('Chat is already open. No notification shown.');
    }
  });
}
